<template>
  <div id="iw-content-menu" class="app_model show" style="z-index: 998;">
    <div class="iw-menu-container" :style="styleobj">
      <div class="iw-menu-hide" :class="{ onShowing: isshow }" @click="show()">
        <div
          class="iw-ui-icon-more"
          :class="{ action: !isshow, revolve: !isshow }"
        ></div>
      </div>
      <div class="iw-ui-button-right" :style="{ display: displaystatus }"></div>
    </div>

    <div class="iw-menu-scroll" :style="styleobj2">
      <div
        v-for="(item, index) in navItems"
        :key="index"
        :name="item.name"
        :type="item.type"
        :iw-click="item.iwClick"
        class="onshow"
        :class="[{ action: isactive[index], startup: index === 0 }]"
        :style="{ left: index * 62 + 'px' }"
        @click="navclik(index)"
      >
        <div
          class="menu_icon"
          :class="[item.icon, { action: isactive[index] }]"
        ></div>
        <span class="text-main" :class="{ action: isactive[index] }">{{ item.label }}</span>
      </div>
    </div>

    <div
      class="iw-menu-cover"
      :class="{ cover1: isshow, cover2: !isshow }"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    nav: ""
  },
  data() {
    return {
      isshow: true,
      index: 0,
      isactive: [],
      // 导航项配置
      navItems: [
        {
          label: '三维鸟瞰',
          icon: 'iw-icon-sanbox-01',
          route: 'Home'
        },
        {
          label: '项目区位',
          icon: 'iw-icon-location',
          route: 'Location'
        },
        
        {
          label: '项目规划',
          icon: 'iw-icon-switch-thumb',
          route: 'plan'
        },
        {
          label: '景观漫游',
          icon: 'iw-icon-garden',
          route: 'Gardens'
        },
        {
          label: '建筑单体',
          icon: 'iw-icon-birdview',
          route: 'Building'
        },
        {
          label: '户型鉴赏',
          icon: 'iw-icon-prototyperoom',
          route: 'Type'
        },
        {
          label: 'VR户型',
          icon: 'iw-icon-button-vr',
          route: 'IndoorVr'
        },
       
        // {
        //   name: '电子楼书',
        //   label: '电子楼书',
        //   icon: 'iw-icon-brochure',
        //   route: 'Brochure'
        // },
        {
         
          label: '计算器',
          icon: 'iw-icon-calculator',
          type: 'iw-icon-calculator',
          iwClick: 'submenu',
          route: 'Calculator'
        },
        // {
        //   label: '室内漫游',
        //   icon: 'iw-icon-switch-thumb',
        //   type: 'iw-icon-switch-thumb',
        //   iwClick: 'submenu',
        //   route: 'IndoorVr'
        // },
        // {
        //   label: '免责声明',
        //   icon: 'iw-icon-picture-02',
        //   type: 'iw-icon-picture-02',
        //   iwClick: 'submenu',
        //   route: 'Shengming'
        // }
      ],
      // 右侧滚动区域 DOM
      rightDiv: undefined,

      // 右侧内容 DOM 数组
      content: undefined,
      displaystatus: "block",
      styleobj: {
        width: "424px",
        left: "10px",
        transition: "width 0s ease 0s, left 0.5s ease 0s, all 0.5s ease 0s"
      },
      styleobj2: {
        width: "388px",
        left: "46px",
        transition: "width 0s ease 0s, left 0.5s ease 0s, all 0.5s ease 0s"
      }
    };
  },
  mounted() {
    // console.log(this.isshow)
    this.rightDiv = document.querySelector(".iw-menu-scroll");
    this.content = document.querySelectorAll(".onshow");
    
    // 初始化 isactive 数组，长度与导航项数量一致
    this.isactive = new Array(this.navItems.length).fill(false);
    
    // 根据当前路由设置激活状态
    this.syncActiveStateWithRoute();
  },
  destroyed() {
    // 取消定时器
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    // 取消节流
    if (this.time && this.time.cancel) {
      this.time.cancel();
    }
  },
  methods: {
    // 根据当前路由同步导航激活状态
    syncActiveStateWithRoute() {
      const currentRouteName = this.$route.name;
      const index = this.navItems.findIndex(item => item.route === currentRouteName);
      
      if (index !== -1) {
        // 重置所有导航项为未激活状态
        this.isactive = new Array(this.navItems.length).fill(false);
        // 设置当前路由对应的导航项为激活状态
        this.isactive[index] = true;
        this.index = index;
        
        // 智能滚动：确保当前导航项在可视区域内
        this.$nextTick(() => {
          if (this.content && this.content[index]) {
            this.scrollToNavIfNeeded(index);
          }
        });
      }
    },

    // 检查导航项是否需要滚动，如果需要则滚动
    scrollToNavIfNeeded(index) {
      if (!this.rightDiv || !this.content || !this.content[index]) return;
      
      const elem = this.content[index];
      const containerLeft = this.rightDiv.scrollLeft;
      const containerRight = containerLeft + this.rightDiv.offsetWidth;
      const elemLeft = elem.offsetLeft;
      const elemRight = elemLeft + elem.offsetWidth;
      
      // 检查元素是否完全在可视区域内
      const isFullyVisible = elemLeft >= containerLeft && elemRight <= containerRight;
      
      // 如果不完全可见，则滚动到居中位置
      if (!isFullyVisible) {
        this.scrollToElem(elem, 600);
      }
    },

    // 导航开关
    show() {
      if (this.isshow) {
        this.styleobj.width = "46px";
        this.styleobj2.width = "0px";
        this.displaystatus = "none";
      } else {
        this.styleobj.width = "424px";
        this.styleobj2.width = "388px";
        this.displaystatus = "block";
      }
      this.isshow = !this.isshow;
    },

    navclik(index) {
      // 重置所有导航项为未激活状态
      this.isactive = new Array(this.navItems.length).fill(false);
      // 设置当前点击的导航项为激活状态
      this.isactive[index] = true;
      
      clearTimeout(this.timeout);
      this.index = index;
      
      // 立即滚动到点击的导航项（如果需要）
      this.$nextTick(() => {
        this.scrollToNavIfNeeded(index);
      });

      // 路由跳转
      const navItem = this.navItems[index];
      if (navItem && navItem.route) {
        this.$router.replace({ name: navItem.route });
      }
    },

    scrollToElem(elem, duration) {
      if (!this.rightDiv || !elem) return;

      // 初始位置
      const startingX = this.rightDiv.scrollLeft;
      
      // 计算目标位置：让元素居中显示
      // 元素左边距 + 元素宽度的一半 - 容器宽度的一半
      const elemCenter = elem.offsetLeft + elem.offsetWidth / 2;
      const containerCenter = this.rightDiv.offsetWidth / 2;
      const targetX = elemCenter - containerCenter;
      
      // 限制滚动范围，避免滚动到容器外
      const maxScroll = this.rightDiv.scrollWidth - this.rightDiv.offsetWidth;
      const finalTargetX = Math.max(0, Math.min(targetX, maxScroll));
      
      // 需要滚动的距离
      const diff = finalTargetX - startingX;
      
      console.log("初始位置", startingX);
      console.log("目标位置", finalTargetX);
      console.log("滚动距离", diff);
      
      if (Math.abs(diff) < 1) return; // 距离太小，不需要滚动

      const that = this;
      // 贝赛尔曲线 (滚动动画)
      const easing = x => 1 - Math.pow(1 - x, 4);

      // 初始滚动时间
      let start;
      window.requestAnimationFrame(function step(timestamp) {
        if (!start) start = timestamp;
        // 计算时间的差值，根据差值计算偏移量
        const time = timestamp - start;
        let percent = Math.min(time / duration, 1);

        percent = easing(percent);
        // 修正公式：起始位置 + 滚动距离 * 进度
        that.rightDiv.scrollTo(startingX + diff * percent, 0);

        if (time < duration) {
          window.requestAnimationFrame(step);
        }
      });
    },
    scrollEvent(e) {
      console.log(e);
      !this.moreLoading; //没有在加载状态，触发加载更多时，把this.moreLoading置未true
      !this.noMore; //没有更多的状态为false，当我们取到的数据长度小于1页的数量时，就没有更多了数据了，把 this.noMore置为true，这样就不会触发无意义的加载更多了
      if (
        e.srcElement.scrollTop + e.srcElement.offsetHeight >
          e.srcElement.scrollHeight - 100 &&
        !this.moreLoading &&
        !this.noMore
      ) {
        this.loadMore();
      }
    }
  },
  watch: {
    $route(to, from) {
      // 路由变化时，同步导航激活状态
      this.syncActiveStateWithRoute();
      
      // if (to.name == "Gardens") {
      //   setTimeout(() => {
      //     this.show();
      //   }, 2500);
      // }
    }
  }
};
</script>

<style scoped>
/* .revolve {
  animation: moving 5s linear infinite;
} */
@keyframes moving {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tabbar.vue